import React from "react";
import { Link } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { initials, roleBadge, fmtDate } from "@/lib/format";

export default function UserBadge({ user, showRole = true, size = "sm" }) {
  if (!user || !user.username) {
    return <span className="text-muted-foreground text-sm">[محذوف]</span>;
  }
  const badge = roleBadge(user.role);
  const sz = size === "lg" ? "h-12 w-12" : size === "md" ? "h-9 w-9" : "h-7 w-7";
  return (
    <Link
      to={`/u/${user.username}`}
      className="inline-flex items-center gap-2 group"
      data-testid={`user-badge-${user.username}`}
    >
      <Avatar className={sz}>
        <AvatarImage src={user.avatar_url || undefined} alt={user.username} />
        <AvatarFallback className="bg-primary/10 text-primary font-eng text-xs">
          {initials(user.username)}
        </AvatarFallback>
      </Avatar>
      <span className="flex items-center gap-1.5">
        <span className="font-eng font-medium text-primary group-hover:underline">
          {user.username}
        </span>
        {showRole && badge && (
          <span className={`text-[10px] font-eng font-semibold px-1.5 py-0.5 rounded ${badge.cls}`}>
            {badge.label}
          </span>
        )}
      </span>
    </Link>
  );
}
